import { OPEN_MODAL, CLOSE_MODAL, ACTIVATE_CAARL_TOUR, DEACTIVATE_CAARL_TOUR } from './index'

export const openModal = (modalName: string, modalProps: unknown) => ({
  type: OPEN_MODAL,
  modalName,
  modalProps,
})

export const closeModal = () => ({
  type: CLOSE_MODAL,
})

export const activateCaarlTour = () => ({
  type: ACTIVATE_CAARL_TOUR,
})

export const deactivateCaarlTour = () => ({
  type: DEACTIVATE_CAARL_TOUR,
})